import { Controller } from "@hotwired/stimulus"
import Validator from "validatorjs"

export default class extends Controller {
  static targets = ["field", "error"]

  validateEmail(event) {
    const email = event.target.value
    const validation = new Validator({ email: email }, { email: 'required|email' })
    
    // Check for test/placeholder domains that should be rejected
    const testDomains = ['example.com', 'example.org', 'example.net', 'test.com', 'test.org', 'localhost']
    const emailDomain = email.toLowerCase().split('@')[1]
    
    if (validation.passes() && testDomains.includes(emailDomain)) {
      this.showError('Please enter a valid email address')
    } else if (validation.passes()) {
      this.clearError()
    } else {
      this.showError(validation.errors.first('email'))
    }
  }

  validateOnSubmit(event) {
    // Check if partner details are visible (indicating partner is selected)
    const partnerDetailsElement = document.querySelector('[data-partner-target="partnerDetails"]')
    const isPartnerSelected = partnerDetailsElement && !partnerDetailsElement.classList.contains('hidden')
    
    // Only validate email if partner is selected
    if (!isPartnerSelected) {
      return true
    }
    
    const email = this.fieldTarget.value
    
    if (!email || email.trim() === '') {
      this.showError('Email is required when partner information is provided')
      event.preventDefault()
      return false
    }

    const validation = new Validator({ email: email }, { email: 'required|email' })
    
    // Check for test/placeholder domains that should be rejected
    const testDomains = ['example.com', 'example.org', 'example.net', 'test.com', 'test.org', 'localhost']
    const emailDomain = email.toLowerCase().split('@')[1]
    
    if (!validation.passes() || testDomains.includes(emailDomain)) {
      this.showError('Please enter a valid email address')
      event.preventDefault()
      return false
    }
    
    return true
  }

  showError(message) {
    this.fieldTarget.classList.add("border-red-500", "focus:ring-red-500", "focus:border-red-500")
    this.fieldTarget.classList.remove("border-[#B9B9B9]", "focus:ring-[#1970E2]", "focus:border-[#1970E2]")
    
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove("hidden")
    }
  }

  clearError() {
    this.fieldTarget.classList.remove("border-red-500", "focus:ring-red-500", "focus:border-red-500")
    this.fieldTarget.classList.add("border-[#B9B9B9]", "focus:ring-[#1970E2]", "focus:border-[#1970E2]")
    
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
      this.errorTarget.classList.add("hidden")
    }
  }
} 